import type { ProductConfig } from "@domain/core/Product";
import type { GenericRecord } from "@domain/models/GenericRecord";
import { Category } from "@domain/models/Category";
import { Creditor } from "@domain/models/Creditor";

export class RecordDraftValidator {
    constructor(private readonly productConfig: ProductConfig) {}

    public canConfirmRecord(record: GenericRecord) {
        const validators: (() => boolean)[] = [
            () => this.validateAccount(record.getRecordCategoryCreditor(), false),
            () => this.validateRecordBelegfeld1(record.num, false),
        ];
        record.items.forEach((item) => {
            validators.push(() => this.validateAccount(item.getCategoryCreditor(), false));
            validators.push(() => this.validateItemBelegfeld1(item.belegfeld1, false));
        });
        return validators.every((v) => v());
    }

    public validateAccount(v: Creditor | Category, isDraftValidation: boolean) {
        return RecordDraftValidator.catCredCheck(v, isDraftValidation);
    }

    public validateRecordBelegfeld1(v: string, isDraftValidation: boolean) {
        if (this.productConfig.useItemBelegfeld1) {
            return true;
        }
        if (!this.productConfig.isRecordBelegfeld1Required) {
            return true;
        }
        if (isDraftValidation) {
            return true;
        }
        v = v || "";
        return v.length > 0;
    }

    public validateItemBelegfeld1(v: string, isDraftValidation: boolean) {
        if (!this.productConfig.useItemBelegfeld1) {
            return true;
        }
        if (!this.productConfig.useItemBelegfeld1Required) {
            return true;
        }
        if (isDraftValidation) {
            return true;
        }
        v = v || "";
        return v.length > 0;
    }

    static catCredCheck(v: unknown, allowEmpty: boolean) {
        if (allowEmpty) {
            if (v === null || v === undefined) {
                return true;
            }
        }
        return (v instanceof Creditor || v instanceof Category) && Boolean(v.num);
    }
}
